import { widgets as ruwidgets } from "src/i18n/dictionaries/ru/widgets";

export const widgets: Record<keyof typeof ruwidgets, string> = {
  // App — авторизация в Telegram WebApp
  "components.App.telegramAuth.loading": "Signing in with Telegram...",
  "components.App.telegramAuth.error":
    "Could not sign in with the Telegram WebApp",

  // Переключатель темы
  "components.atoms.Toggle.light": "Light",
  "components.atoms.Toggle.dark": "Dark",
  "components.atoms.Toggle.switchToLight": "Switch to the light theme",
  "components.atoms.Toggle.switchToDark": "Switch to the dark theme",

  // Календарь: названия месяцев в шапке
  "components.atoms.Calendar.month.1": "January",
  "components.atoms.Calendar.month.2": "February",
  "components.atoms.Calendar.month.3": "March",
  "components.atoms.Calendar.month.4": "April",
  "components.atoms.Calendar.month.5": "May",
  "components.atoms.Calendar.month.6": "June",
  "components.atoms.Calendar.month.7": "July",
  "components.atoms.Calendar.month.8": "August",
  "components.atoms.Calendar.month.9": "September",
  "components.atoms.Calendar.month.10": "October",
  "components.atoms.Calendar.month.11": "November",
  "components.atoms.Calendar.month.12": "December",

  // Заглушки заголовка события (когда бэкенд не прислал title)
  "components.molecules.EventDetailInfo.titleFallback":
    "Will Adam Kadyrov receive an award in October 2024",
  "components.organisms.BettingCard.titleFallback":
    "Will Adam Kadyrov receive an award in October 2024",

  // Карточка события: объём торгов
  "components.molecules.FavoriteCard.amount": "{amount}K",

  // Экран падения приложения
  "components.organisms.ErrorBoundary.title": "Something went wrong",
  "components.organisms.ErrorBoundary.description":
    "This page could not be displayed. Going back to the home page usually fixes it.",
  "components.organisms.ErrorBoundary.button": "Go to home",

  // Подписи линий графика (видны в тултипе)
  "components.organisms.Chart.series.yes": "YES",
  "components.organisms.Chart.series.no": "NO",

  // Обучающая модалка — вёрстка на абсолютных координатах, держим текст
  // не длиннее русского оригинала.
  "components.organisms.OnboardingModal.step1.title": "Pick a market",
  "components.organisms.OnboardingModal.step1.text":
    "This is a prediction market where users create the markets themselves and drive their pricing. Trade events across hundreds of categories, from Finance to Media",
  "components.organisms.OnboardingModal.step2.title": "Make a forecast",
  "components.organisms.OnboardingModal.step2.line1":
    "Fund your entry stake with a",
  "components.organisms.OnboardingModal.step2.line2":
    "deposit via any payment method.",
  "components.organisms.OnboardingModal.step2.line3":
    'Go back to the market and pick "Yes"',
  "components.organisms.OnboardingModal.step2.line4":
    'or "No" based on your forecast',
  "components.organisms.OnboardingModal.step3.title": "Earn profit",
  "components.organisms.OnboardingModal.step3.text":
    "Wait until the event the market is tied to is resolved. The payout will then land in your balance",

  // Промокод: экран «применён»
  "components.organisms.PromoCodeModal.applied.title": "Promo code applied",
  "components.organisms.PromoCodeModal.applied.text":
    "Deposit {minDeposit} ₸ or more and get a {bonus} ₸ bonus",
  "components.organisms.PromoCodeModal.applied.button": "Got it",

  // Подсказка «как это работает» на карточке ставки
  "components.organisms.QuestionModal.title": "Buy tokens — earn profit!",
  "components.organisms.QuestionModal.text":
    'The token price reflects the probability of the selected outcome. Enter an amount within the maximum and press "Confirm". If the event resolves to your outcome, you receive the payout shown.',

  // Реферальная программа: копирование промокода
  "components.organisms.ReferalInfo.copy.success": "Promo code copied",
  "components.organisms.ReferalInfo.copy.error": "Could not copy",

  // Ставка: выбранный исход в шапке модалки
  "components.organisms.BettingModal.choice": "Choice: {value}",
  "components.organisms.BettingModal.choice.yes": "Yes",
  "components.organisms.BettingModal.choice.no": "No",

  // Ставка: исход не выбран (тост)
  "components.organisms.BettingCard.chooseOutcomeToast": "Select an outcome",

  // График: история сделок пуста
  "utils.charts.noBets": "No bets yet",

  // Тексты уведомлений слоя запросов
  "queries.common.error": "Something went wrong",
  "queries.useCreateBet.priceChanged":
    "The price changed from {expectedPrice} to {currentPrice}. Data has been refreshed, please try again.",
  "queries.useCreateWallet.error":
    "Could not create the wallet. Please try again later.",
  "queries.useCreateWithdrawal.success": "Withdrawal request created",
  "queries.useCreateWithdrawal.error": "Could not create the withdrawal",
};
